<app-table
  *ngIf="cols"
  [cols]="cols"
  pageFunctionName="getStockEntriesList"
  [service]="stockEntryService"
  modelName="registros"
  sortField="createdAt"
  [sortOrder]="-1"
  [defaultRows]="10"
  [changeColumns]="true"
  [addButton]="false"
/>
